import React, {useContext, useEffect, useRef} from 'react';
import Button from "../../../common/primitives/Button";
import HelperGoogleAnalytics4 from "../../../common/helpers/HelperGoogleAnalytics4";
import styles from './Banners.scss';
import Price from "../../../common/primitives/Price";
import PropTypes from "prop-types";
import {__t} from "../../../common/lang/text-resource";

function Banners({...props}) {
	const lang = SHVO.pageLang ?? 'bg';

	const viewPlans = () => {
		HelperGoogleAnalytics4.TrackEvent("HomePage Events", "View Plans Button", "Homepage-left");
		window.location = '/web-hosting-compare-hosting-plans.php'
	}

	const viewDomains = () => {
		HelperGoogleAnalytics4.TrackEvent('HomePage Events', 'Find Domain Button', 'Homepage-right')
		window.location = "/web-hosting-register-domains.php"
	}
	const banner = useRef();

	const scaleContent = () => {
		const mainServices = document.getElementById('JS_HomePage_MainServices');
		if (window.innerWidth < 1280) {
			banner.current.style.scale = 1;
			mainServices.style.marginTop = '44px';
			return;
		}

		let perpx = 1 / 1280;
		let ratio = perpx * window.innerWidth;

		// след 1800px не увеличаваме повече
		if (ratio > 1.4) {
			ratio = 1.4;
		}

		banner.current.style.scale = ratio;

		const originalHeight = banner.current.clientHeight;
		const marginTop = 44 + ((originalHeight * ratio) - originalHeight);
		mainServices.style.marginTop = marginTop + 'px';
	}

	useEffect(() => {
		scaleContent();
		window.addEventListener('resize', scaleContent, false);
		return () => {
			window.removeEventListener('resize', scaleContent, false);
		}
	}, [])

	return (
	  <div ref={banner} className={styles.featured}>
		  <div>
			  <div className={`${styles.innerLeft} ${lang === 'en' ? styles.innerLeft_en : ''}`}>
				  <div className={styles.priceElement}>
					  <a href="/web-hosting-compare-hosting-plans.php">{__t('Хостингhm')}</a>
					  <div className={styles.contentHolder}>
						  <h1>{__t('Сигурен хостинг')}</h1>

						  <div className={styles.websiteText1}>
							  <span>{__t('над')}</span>
							  <span>200 000</span>
						  </div>
						  <div className={styles.websiteText2}>{__t('уебсайта')}</div>
						  <div className={styles.websiteText3}>{__t('вече ни се довериха!')}</div>

						  <div className={styles.descHolder}>
							  <div className={styles.plusIcon}></div>
							  <div className={styles.description}>
								  {__t('с-опция-за-4392jfjofj22', null, true)}
							  </div>
						  </div>

						  <div className={styles.orderButton} onClick={viewPlans}></div>
					  </div>
				  </div>
			  </div>
		  </div>

		  <div>
			  <div className={styles.innerRight}>
				  <a href="/web-hosting-register-domains.php">{__t('Домейни')}</a>
				  <h2>{__t('Искаш сайт? Започни с името!')}</h2>
				  <p>{__t('Вземи .COM домейн само за')}&nbsp;
					  <Price currency={props.currency} value={props.comPrice}
							 includeDotAfterLV={false}/>
					  {SHVO.showEuroPrices && <>&nbsp;/&nbsp;
						  <Price
							currency={'EUR'} value={props.comPrice / 1.95583}
							includeDotAfterLV={false}/>
					  </>}
					  !*</p>
				  <Button
					value={__t('Открий своя домейн')}
					onClick={viewDomains}/>
				  <div className={styles.rightPrcFirstYear}>{__t('* Цена с ДДС за първата година.')}</div>
			  </div>
		  </div>

	  </div>
	)
}

Banners.propTypes = {
	currency: PropTypes.string,
	comPrice: PropTypes.string
}

export default Banners;